import {useResponsive} from '@/contexts/ResponsiveContext';
import InSituMeasureDesktopView from './InSituMeasureDesktopView';
import InSituMeasureTabletView from './InSituMeasureMobileView';
import {memo} from 'react';
import PropTypes from 'prop-types';

const TemplateDetailsInSituMeasure = ({question, sectionId, runAudit}) => {
  const { isTablet } = useResponsive();

  if(isTablet) return <InSituMeasureTabletView question={question} sectionId={sectionId} runAudit={runAudit} />;
  return <InSituMeasureDesktopView question={question} sectionId={sectionId} runAudit={runAudit} />;
};

TemplateDetailsInSituMeasure.propTypes = {
  question: PropTypes.object,
  runAudit: PropTypes.bool,
  sectionId: PropTypes.string,
};

TemplateDetailsInSituMeasure.defaultProps = {
  question: {},
};

export default memo(TemplateDetailsInSituMeasure);
